import { KitWelcomeModal } from './KitWelcomeModal';
import { LiteWelcomeModal } from './LiteWelcomeModal';
import { type WelcomeModalProps } from './types';

export function WelcomeModal({ variant = 'kit', ...props }: WelcomeModalProps) {
    if (variant === 'lite') {
        return <LiteWelcomeModal {...props} />;
    }

    return <KitWelcomeModal {...props} />;
}
